import { LoginForm, RegisterForm } from '@/features/auth'
import { AuthPage } from './ui/AuthPage'

export function LoginPage() {
  return (
    <AuthPage title="Вход в кабинет" subtitle="Продолжим с того места, где остановились">
      <LoginForm />
    </AuthPage>
  )
}

export function RegisterPage() {
  return (
    <AuthPage
      title="Регистрация компании"
      subtitle="Три поля — и сразу к настройке агента разговором"
    >
      <RegisterForm />
    </AuthPage>
  )
}
